import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { processSteps } from '../../data/process';
import { SectionHeading } from '../ui/SectionHeading';
export function Process() {
  const {
    t,
    b
  } = useLanguage();
  return <section id="process" className="scroll-mt-24 bg-white py-20 md:py-24" aria-labelledby="process-title" data-id="element-294" data-mp="p28bbtgykooo">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8" data-id="element-295" data-mp="k4gkl2s1v8m2">
        <SectionHeading id="process-title" title={t('process.title')} subtitle={t('process.sub')} data-id="element-296" data-mp="3skiagzjap79k" />

        <ol className="mt-16 grid gap-10 lg:grid-cols-5 lg:gap-6" data-id="element-297" data-mp="3nlf5ff3bf11l">
          {processSteps.map((step, index) => {
          const Icon = step.icon;
          return <li key={step.title.en} className="relative flex gap-5 lg:block" data-id="element-298" data-mp="1cnpn2tf7dbp" data-mpi={index}>
                {index < processSteps.length - 1 && <div className="absolute left-6 top-14 h-[calc(100%+1.75rem)] w-px bg-navy/10 lg:left-12 lg:right-0 lg:top-6 lg:h-px lg:w-auto" aria-hidden="true" data-id="element-299" data-mp="39ref99qfimcu" />}
                <div className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-navy font-display text-lg font-extrabold text-white" data-id="element-300" data-mp="2rqwovg8xk923">
                  {index + 1}
                </div>
                <div className="lg:pr-6 lg:pt-6" data-id="element-301" data-mp="30jq6hkbunkj4">
                  <Icon className="hidden h-6 w-6 text-brand-700 lg:block" aria-hidden="true" data-id="element-302" data-mp="30if33lmbgesj" />
                  <h3 className="mt-0 font-display text-base font-bold text-navy lg:mt-4" data-id="element-303" data-mp="23usbc106tklf">{b(step.title)}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-304" data-mp="28u4zqq6pizq4">{b(step.description)}</p>
                  <p className="mt-3 text-xs font-bold uppercase tracking-wide text-cta-dark" data-id="element-305" data-mp="2cvqg4lig9w52">{b(step.meta)}</p>
                </div>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}